import { FormFieldTypes } from "../../data/formFieldType";

const ForgetPasswordFormData = {
  name: "Forget Password Form",
  initialState: {
    emailAddress: "",
  },
  formFields: [
    {
      id: "emailAddress",
      lable: "Enter the email to retrieve your account",
      Field_Name: "Enter the email to retrieve your account",
      fieldType: FormFieldTypes.INPUT,
      dataField: "emailAddress",
      fieldSetting: {
        placeholder: "Email address",
        allowSpace: false,
      },
      validation: [{ type: "require" }, { type: "email" }],
      style: {
        containerCss: "col-md-12 mb-3",
      },
    },
  ],
};

export default ForgetPasswordFormData;
